import React from 'react';

export const Spinner = () => {
  return <span><div data-uk-spinner></div></span>
}
